const fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result) {
                const base64String = reader.result
                    .toString()
                    .replace('data:', '')
                    .replace(/^.+,/, '');

                resolve(base64String);
            } else {
                reject(new Error('Failed to read file.'));
            }
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

export interface Attachment {
    attachment: Record<string, any>; // Use `Record<string, any>` for a generic object
    objectEntryId: number;
  }

export const processUploadedFiles = async (
    files: File[],
    objectEntryId: number = 0
): Promise<Attachment[]> => {
    const uploadedFilesData: {
        attachment: {};
        objectEntryId: number;
    }[] = [];

    for (const file of files) {
        try {
            const result = await fileToBase64(file);
            if (result) {
                uploadedFilesData.push({
                    attachment: { fileBase64: result, name: file.name },
                    objectEntryId
                });
            }
        } catch (error) {
            console.error('Error processing file:', file.name, error);
        }
    }

    return uploadedFilesData;
};

export const handleUpload = async (files: any[], allAttachments: any[]) => {
    await Promise.all(
        files.map(async (item) => {
            // ✅ Existing file (already uploaded)
            if (item?.externalReferenceCode || !(item instanceof File)) {
                allAttachments.push({
                    attachment: {
                        id: item?.id,
                        link: { href: item?.href, label: item?.documentName },
                        name: item?.documentName
                    },
                    externalReferenceCode: item?.externalReferenceCode
                });
                return;
            }

            // ✅ New file → upload
            if (item instanceof File) {
                const doc = await processUploadedFiles([item]);
                allAttachments.push(doc[0]);
            }
        })
    );
};


// export function base64ToFile(base64String: string, fileName: string, mimeType: string): File {
//     const byteCharacters = atob(base64String.split(',')[1]);
//     const byteNumbers = new Array(byteCharacters.length)
//       .fill(null)
//       .map((_, i) => byteCharacters.charCodeAt(i));
//     const byteArray = new Uint8Array(byteNumbers);
//     const blob = new Blob([byteArray], { type: mimeType });
  
//     return new File([blob], fileName, { type: mimeType });
//   }

export function base64ToFile(base64String: string, fileName: string, mimeType: string): File {
    // Ensure the base64 string has a prefix (if necessary)
    const base64Data = base64String.includes(',') ? base64String.split(',')[1] : base64String;
  
    try {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(null)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
  
      return new File([blob], fileName, { type: mimeType });
    } catch (error) {
      console.error('Invalid base64 string', error);
      throw new Error('Invalid base64 format');
    }
  }
  
export const convertDocumentItemToFile = async (item: any): Promise<File> => {
    const fileName = item.documentName || item.name;
    const fileUrl = item.href; // must be accessible URL

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    return new File([blob], fileName, {
        type: blob.type || "application/octet-stream",
        lastModified: Date.now(),
    });
};